import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { RescueModel } from '../../Models/MiniGames/RescueModel';

@Singleton
export class RescueLogic {
    stepMax = 0.0075*7/2;
    stepAutomatic: number = 0.0075;
    stepUp: number = 0.0075*10/2;
    step: number = 0.5;
    maxPosition: number = 2;
    minPosition: number = 0;

    constructor(
        @Inject private _model: RescueModel,
        @Inject private _modelEvents: ModelEvents,
    ) {
    }

    public init(): void {
        this._model.sliderValue = 1;
    }

    public run(): void {
        this._model.running = true;
    }

    public stop(): void {
        this._model.running = false;
        this._model.isShowHintAllowed = false;
    }

    public running(): boolean {
        return this._model.running;
    }

    public sliderValue(): number {
        return this._model.sliderValue;
    }

    public isShowHintAllowed(): boolean {
        return this._model.isShowHintAllowed;
    }

    public reducingAutomatickPosition(fps: number= 30): number {
        if (this._model.sliderValue > this.minPosition) {
            return this._model.sliderValue -= this.stepAutomatic * 30* fps;
        }
    }

    public forward(fps: number = 30): number {
        // if (this._model.running && (this._model.sliderValue < this.maxPosition)) {
        return this._model.sliderValue += this.stepUp * 30 * fps;
        // }
    }

    public reducingPosition(): void {
        if (!this._model.isShowHintAllowed) {
            this._model.running = true;
            this._model.isShowHintAllowed = true;
        }
        this._model.sliderValue = Math.max(this._model.sliderValue - this.step, this.minPosition);
    }

    public increasePosition(): void {
        if (!this._model.isShowHintAllowed) {
            this._model.running = true;
            this._model.isShowHintAllowed = true;
        }
        this._model.sliderValue = Math.min(this._model.sliderValue + this.step, this.maxPosition);
    }
    public increaseHardness(): void {
        if(this.stepAutomatic < this.stepMax){
            this.stepAutomatic += 0.001;
        }
    }

    public reset(): void {
        this._model.sliderValue = 0;
        this._model.isForward = false;
    }

    public setForward(forward: boolean){
        if (forward && !this._model.running){
            this._model.sliderValue = 1;
            this._model.running = true;
            this._model.isShowHintAllowed = true;
        }
        this._model.isForward = forward;
        console.log("forward " + forward)
    }
}
